var _circle, _path, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 30.5,
    stroke: "#2D63F9",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9208 36.4219C53.6146 35.25 54 34 54 32.5156C54 29.0781 51.0708 25.875 47.3708 25.875H44.5188C44.9042 24.8594 45.2125 23.6875 45.2125 22.2031C45.2125 16.5 42.2833 14 37.8896 14C33.1104 14 33.4188 21.4219 32.3396 22.5156C30.5667 24.3125 28.4854 27.75 27.0208 29H19.4667C18.0792 29 17 30.1719 17 31.5V50.25C17 51.6562 18.0792 52.75 19.4667 52.75H24.4C25.4792 52.75 26.4813 51.9688 26.7125 50.9531C30.1813 51.0312 32.5708 54 40.4333 54C41.05 54 41.6667 54 42.2063 54C48.1417 54 50.7625 50.9531 50.8396 46.5781C51.9188 45.1719 52.4583 43.2188 52.2271 41.3438C52.9979 39.9375 53.2292 38.2188 52.9208 36.4219ZM48.1417 40.6406C49.1437 42.2812 48.2188 44.4688 47.0625 45.1719C47.6792 48.9219 45.675 50.25 42.9771 50.25H40.0479C34.575 50.25 30.9521 47.3594 26.8667 47.3594V32.75H27.6375C29.8729 32.75 32.8792 27.2812 34.9604 25.1719C37.1187 22.9844 36.425 19.2344 37.8896 17.75C41.5125 17.75 41.5125 20.3281 41.5125 22.2031C41.5125 25.25 39.3542 26.6562 39.3542 29.625H47.3708C48.9896 29.625 50.2229 31.1094 50.3 32.5938C50.3 34 49.2979 35.4844 48.5271 35.4844C49.6063 36.6562 49.8375 39.0781 48.1417 40.6406ZM23.7833 47.75C23.7833 48.8438 22.9354 49.625 21.9333 49.625C20.8542 49.625 20.0833 48.8438 20.0833 47.75C20.0833 46.7344 20.8542 45.875 21.9333 45.875C22.9354 45.875 23.7833 46.7344 23.7833 47.75Z",
    fill: "#2D63F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 47.75,
    r: 1.5,
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.f67a0e4614492790c435b197e3698167.svg";
export { ForwardRef as ReactComponent };